import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useUserEventLogger } from '@repo/tracking-service';
import { AdditionalInfo, BoxButton, Drawer, DrawerContent, DrawerFooter, DrawerHeader, MainTitle, ModalStickyBottomWrapper, useToast } from '@repo/ui';
import { useAtom } from 'jotai';
import { useState } from 'react';
import { useMount } from 'react-use';

import { AutographPad } from './AutographPad.tsx';

import { autographAtom } from '@/lib/stores/power-of-attorney.ts';
import { AutographValidationResult } from '@/lib/types/power-of-attorney.ts';

export const AutographDrawer = NiceModal.create(({ name }: { name?: string }) => {
  const modal = useModal();
  const { toast } = useToast();
  const [autograph, setAutograph] = useAtom(autographAtom);
  const [autographValidation, setAutographValidation] = useState<AutographValidationResult>({
    isValid: false
  });
  const { sendViewEvent, sendClickEvent } = useUserEventLogger();

  const handleClose = () => {
    sendClickEvent('request_autograph_pad_close');
    setAutograph('');
    modal.resolve(undefined);
    modal.hide();
  };

  const handleConfirm = () => {
    if (!autographValidation.isValid) {
      toast({
        variant: 'warning',
        title: '서명을 올바르게 작성해 주세요.'
      });
      return;
    }

    sendClickEvent('request_autograph_pad_complete');
    modal.resolve(autograph);
    setAutograph('');
    modal.hide();
  };

  useMount(() => {
    sendViewEvent('request_autograph_pad', undefined, { isAllowRetry: true });
  });

  return (
    <Drawer open={modal.visible} dismissible={false}>
      <DrawerContent outSideClickAction={handleClose}>
        <DrawerHeader className={'!pb-5'}>
          <MainTitle title={'성함을 정자로 작성해주세요'} size={'small'} className={'!p-0'} />
        </DrawerHeader>
        <div className={'flex flex-col gap-normal-small container-padding-medium pb-normal-large'}>
          <AutographPad guideString={name} onValidationChange={setAutographValidation} />
        </div>
        <DrawerFooter className={'flex flex-col gap-normal-small items-center'}>
          <div className={'container-padding-medium text-center w-full text-nowrap'}>
            <AdditionalInfo info={' 작성한 서명은 국세청 제출용 신고서류에도 반영돼요.'} className={'!p-0'} divider={false} />
          </div>
          <ModalStickyBottomWrapper className={'w-full'}>
            <BoxButton size={'large'} variant={'filled-primary'} onClick={handleConfirm} disabled={!autograph} className={'w-full'}>
              완료
            </BoxButton>
          </ModalStickyBottomWrapper>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
});
